export { IconFont } from './IconFont';
export { LazyLoader as IconFontLoader } from './LazyLoader';
